<template>
    <div class="flex" @click="markRead()">
        <div class="bg-gray-100 py-3 px-4 w-full hover:border-gray-400 border border-gray-100 transition cursor-pointer">
            <div>
                <h1 class="text-primary font-bold">{{ title }}</h1>
                <p class="text-[10px] text-[#9A999E]">{{ formatDate(dataCreated) }}</p>
            </div>
            <div>
                <p class="text-sm text-[#5B5B5F]">{{ text }}</p>
                <p class="text-sm text-[#5B5B5F]">{{ hyperlink }}</p>
            </div>
        </div>
        <div class="h-[9px] w-[9px] self-center">
            <transition name="bounce">
                <div v-if="!asRead" class="h-[9px] w-[9px] bg-primary rounded-full self-center ml-2"></div>
            </transition>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import 'moment/locale/pt-br';

export default {
    props: {
        asRead: Boolean,
        title: String,
        dataCreated: String,
        text: String,
        hyperlink: String,
        notificationId: String
    },
    methods: {
        markRead() {
            axios.put(this.route("dashboard.readNotification"), {
                notificationId : this.notificationId,
                userId : this.$page.props.auth.user.id
            })

            this.$emit('foiLido');
            if(this.hyperlink.includes('https://')) {
                window.open(this.hyperlink, "_blank");
            }
        },
        formatDate(date) {
            return moment(date).locale("pt-br").format('DD/MM/YYYY HH:mm:ss');
        }
    }

}
</script>
<style scoped>
    .bounce-leave-active {
        animation: fade-out 0.5s reverse;
    }
    @keyframes fade-out {
        0% {
            opacity: 0;
        }
    }
</style>
